import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Container, Box, Grid, RichText, SingleMessage, TAGAccordions, TAGTypography, useMediaQuery, Content } from '../..';

function getRichOrMsg(richOrMsg) {
  if (richOrMsg.__typename.slice(10) === 'RichText') {
    return React.createElement(RichText, _objectSpread({}, richOrMsg));
  } else if (richOrMsg.__typename.slice(10) === 'Content') {
    return React.createElement(Content, _objectSpread({}, richOrMsg));
  } else {
    return React.createElement(SingleMessage, _objectSpread({}, richOrMsg));
  }
}

var Columns = function Columns(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'white' : _ref$backgroundColor,
      columns = _ref.columns,
      description = _ref.description,
      eyebrow = _ref.eyebrow,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$mobileDisplayAcc = _ref.mobileDisplayAccordion,
      mobileDisplayAccordion = _ref$mobileDisplayAcc === void 0 ? false : _ref$mobileDisplayAcc,
      title = _ref.title;
  var mobileWidth = useMediaQuery('(max-width:600px)');
  var isDark = backgroundColor === 'dark';

  var _columns$reduce = columns.reduce(function (prev, curr) {
    if (curr != null) {
      prev[0].push(curr.title);
      prev[1].push(getRichOrMsg(curr));
    }

    return prev;
  }, [[], []]),
      _columns$reduce2 = _slicedToArray(_columns$reduce, 2),
      titles = _columns$reduce2[0],
      accordions = _columns$reduce2[1];

  return React.createElement(Grid, {
    sx: {
      backgroundColor: fullWidth ? "backgrounds.".concat(backgroundColor) : ''
    }
  }, React.createElement(Container, {
    sx: {
      backgroundColor: "backgrounds.".concat(backgroundColor)
    }
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    sx: {
      padding: '20px 0'
    }
  }, React.createElement(Grid, {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    mb: "20px"
  }, eyebrow && React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodySmallBook' : 'bodyMediumBook',
    color: isDark ? 'text.light' : 'text.secondary'
  }, eyebrow), title && React.createElement(TAGTypography, {
    variant: "h1",
    color: isDark ? 'text.light' : 'text.primary',
    sx: {
      margin: '12px 0'
    }
  }, title), (description === null || description === void 0 ? void 0 : description.description) && React.createElement("p", null, React.createElement(TAGTypography, {
    variant: mobileWidth ? 'bodyMediumBook' : 'bodyLargeBook',
    color: isDark ? 'text.light' : 'text.secondary'
  }, description === null || description === void 0 ? void 0 : description.description))), mobileWidth && mobileDisplayAccordion ? React.createElement(TAGAccordions, {
    boxBgColorDark: false,
    button: false,
    titles: titles
  }, accordions) : React.createElement(Grid, {
    container: true,
    columnSpacing: 4,
    direction: "row",
    wrap: "".concat(mobileWidth ? 'wrap' : 'nowrap')
  }, columns && columns.map(function (column) {
    if (column) {
      return React.createElement(Grid, {
        item: true,
        sx: {
          width: '100%',
          paddingTop: '20px'
        }
      }, getRichOrMsg(column));
    } else {
      return null;
    }
  })))));
};

export default Columns;